module.exports = __webpack_public_path__ + "static/img/14.7a54bc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/14.png
// module id = mTDP
// module chunks = 0